import {SwitchButton} from "../../../../Layout/Shared/SwitchButtonBlue";
import {GridTwoColumn} from "../../../../Layout/Shared/GridTwoColumn";

export const TextandMessages = ({status, onChange}) => {
  return (
    <GridTwoColumn>
      <div>
        <h4 className="font-weight-bold pb-2">Text & Messages </h4>
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet.
        </p>
      </div>
      <div>
        <SwitchButton status={status} onChange={onChange} />
      </div>
    </GridTwoColumn>
  );
};
